import { useQueryLoader, useRelayEnvironment } from "react-relay";
import { fetchQuery } from "relay-runtime";
import { useDebouncedCallback } from "use-debounce";
import {
  WACalendarOverviewPreviewQuery,
  WACalendarOverviewPreviewQuery$variables,
} from "./__generated__/WACalendarOverviewPreviewQuery.graphql";
import { WA_CALENDAR_OVERVIEW_PREVIEW_QUERY } from "./WACalendarOverviewPreview";

export function useWidgetCalendarPreviewOverviewQuery(props: {
  storecastId: string;
}) {
  const [previewQuery, loadPreview] =
    useQueryLoader<WACalendarOverviewPreviewQuery>(
      WA_CALENDAR_OVERVIEW_PREVIEW_QUERY
    );
  const environment = useRelayEnvironment();

  const loadPreviewQuery = useDebouncedCallback(
    async (newCalendarIds: string[]) => {
      try {
        const variables: WACalendarOverviewPreviewQuery$variables = {
          storecastId: props.storecastId,
          input: {
            size: "TWO_X_FOUR",
            calendarIds: newCalendarIds,
          },
          first: 20,
        };
        await fetchQuery(
          environment,
          WA_CALENDAR_OVERVIEW_PREVIEW_QUERY,
          variables
        ).toPromise();
        loadPreview(variables);
      } catch {}
    },
    300
  );
  return [previewQuery, loadPreviewQuery] as const;
}
